import React from "react";
import "../styles/Projects.css";
import ArrowForwardRoundedIcon from "@material-ui/icons/ArrowForwardRounded";
import FadeInSection from "./FadeIn";
import ExternalLinks from "./ExternalLinks";

class Projects extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: true,
      activeKey: "1"
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect(eventKey) {
    this.setState({
      activeKey: eventKey
    });
  }
  render() {
    const projects = {
      "Cijiji - N/A": {
        desc:
          "Buy and sell app like Kijij. Currently in development.",
        techStack: "React.js, HTML/CSS, RestAPI, Postgress, Nodejs(Express)",
        link: "",
        open: ""
      },
      "Book'd": {
        desc:
          "A barbershop app for booking appointments & adding shops to a map.",
        techStack: "React.js, HTML/CSS, RestAPI, Postgress, Nodejs(Express)",
        link: "https://github.com/Estuardo-sanchez/final-project",
        open: ""
      },
      "Verdict": {
        desc:
          "A decision making app used to create a poll and vote with friends.",
        techStack: "EJS, JavaScript, SCSS, shell",
        link: "https://github.com/Donnadonnana/verdict",
        open: ""
      },
      "Wordle Clone": {
        desc:
          "A clone based off the wordle game.",
        techStack: "React.js, HTML/CSS, Nodejs(Express)",
        link:
          "https://github.com/Cxlopez/Wordl-Clone",
        open: ""
      },
      "Todo List": {
        desc:
          "A todo list app to keep track of daily tasks.",
        techStack: "React.js, HTML/CSS, Nodejs(Express)",
        link: "https://github.com/Cxlopez/Todo-list",
        open: ""
      },
      "Scheduler": {
        desc:
          "An app to schedule appointments with teachers.",
        techStack: "JavaScript, HTML, SCSS, shell",
        link: "https://github.com/Cxlopez/scheduler",
        open: ""
      }
    };

    return (
      <div id="projects">
        <div className="section-header ">
          <span className="section-title">My Creations</span>
        </div>
        <div className="project-container">
          <ul className="projects-grid">
            {Object.keys(projects).map((key, i) => (
              <FadeInSection delay={`${i + 1}00ms`} key={i}>
                <li className="projects-card">
                  <div className="card-header">
                    <div className="folder-icon">
                      <ArrowForwardRoundedIcon
                        style={{ fontSize: 35 }}
                      ></ArrowForwardRoundedIcon>
                    </div>
                    <ExternalLinks
                      githubLink={projects[key]["link"]}
                      openLink={projects[key]["open"]}
                    ></ExternalLinks>
                  </div>

                  <div className="card-title">{key}</div>
                  <div className="card-desc">{projects[key]["desc"]}</div>
                  <div className="card-tech">{projects[key]["techStack"]}</div>
                </li>
              </FadeInSection>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default Projects;